<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="maegarante"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmmaegarante" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>


<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        
        <app-invmaebarra (signal)="manejarSenales($event)" [barraBotones3]="barraBotones2"
            [barraBotonesAsiCon]="barraBotones2" [botonBorrar]="botonBorrar" [botonNuevo]="botonNuevo"
            [botonGuardar]="botonGuardar" [botonBuscar]="false" [botonRegresar]="botonRegresar" [barraBotones5]="false"
            [botonPrimero]="!botonPrimero" [botonAnterior]="!botonAnterior" [botonSiguiente]="!botonSiguiente"
            [botonUltimo]="!botonUltimo" [botonAlmacenardoc]="true" [botonBinocular] ="true"
            [botonIMP]="false"></app-invmaebarra>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()">
    <p-tabPanel header="Generales">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 250px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <span class="obligatorio">Tipo ID:</span>
                                </div>
                                <div class="p-col-2">
                                    <p-dropdown [options]="cmbide" [style]="{'minWidth': '100%', 'width':'100%'}"
                                        optionLabel="name" [panelStyle]="{'width':'110%'}" [(ngModel)]="selectide"
                                        (onChange)="busqide()"></p-dropdown>
                                </div>
                                <div class="p-col-1">
                                    <span class="obligatorio">RUC / IDE</span>
                                </div>
                                <div class="p-col-2">
                                    <div class="p-grid">
                                        <div class="p-col-10">
                                            <label for="GAR_ID"></label>
                                            <input class="frm" id="GAR_ID" type="text" pInputText
                                                [(ngModel)]="cxcgarante.GAR_ID" (keydown.enter)="setFocus($event)"
                                                (keydown)="botmodclirucide()" 
                                                maxlength="25"
                                                autocomplete="off" style="text-transform: uppercase;">
                                        </div>
                                        <div class="p-col-2">
                                            <button type="button"
                                                style="background-image: url(../../../assets/images/iconos/visto.webp);"
                                                (click)="validar(cxcgarante.GAR_ID)"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-2">
                                    <div class="p-grid">
                                        <div class="p-col-3">
                                            <span>{{lblvalida}}</span>
                                        </div>
                                        <div class="p-col-9">
                                            <!-- <span class="obligatorio">Código</span> -->
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -25px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <span class="obligatorio">Nombre:</span>
                                </div>
                                <div class="p-col-2">
                                    <label for="GAR_NOMBRE"></label>
                                    <input class="frm" id="GAR_NOMBRE" type="text" pInputText
                                    maxlength="200"
                                        [(ngModel)]="cxcgarante.GAR_NOMBRE" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()"  autocomplete="off">
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-2">
                                    <div class="p-grid">

                                        <div class="p-col-6">
                                            <span class="obligatorio">F. Nacimiento:</span>
                                        </div>
                                        <div class="p-col-6">
                                            <p-calendar id="GAR_FECNAC" [inputStyle]="{width: '100%', height: '20px'}"
                                                [(ngModel)]="cxcgarante.GAR_FECNAC" dateFormat="dd/mm/yy"
                                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()">
                                            </p-calendar>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-col-1">
                                    <span class="obligatorio">Sexo:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_SEXO"></label>
                                    <input class="frm" id="GAR_SEXO" type="text" pInputText
                                    maxlength="2"
                                        [(ngModel)]="cxcgarante.GAR_SEXO" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="busquedasexo(cxcgarante.GAR_SEXO)"></button>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_SEXONOMBRE"></label>
                                    <input class="frm" id="GAR_SEXONOMBRE" type="text" pInputText disabled
                                        [(ngModel)]="cxcgarante.GAR_SEXONOMBRE" autocomplete="off">
                                </div>


                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -20px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <div class="p-grid">

                                        <div class="p-col-9">
                                            <span class="obligatorio">Nacionalidad:</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-2">
                                    <!-- <p-dropdown [options]="cmbNacio" [style]="{'width': '100%'}"
                                    [(ngModel)]="valorNacio" optionLabel="nacnombre"
                                    [panelStyle]="{'width':'110%'}"
                                    id="inp_Nacio" 
                                    (onChange)="cambioOptionNac($event)" (keydown.enter)="cambiarFocoNac($event)"
                                    ></p-dropdown> -->

                                    <p-dropdown [options]="cmbNacio" 
                                    optionLabel="name"  [(ngModel)]="valorNacio"
                                    
                                    (onChange)="cambioOptionNac($event)"></p-dropdown>
                                    
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <span class="obligatorio">Edad:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_EDAD"></label>
                                    <input class="frm" id="GAR_EDAD" type="text" pInputText oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                    maxlength="3"
                                        [(ngModel)]="cxcgarante.GAR_EDAD" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">
									<span class="obligatorio">Est. Civil:</span>
								</div>
								<div class="p-col-1">
									<label for="GAR_ESTCIVIL"></label>
									<input class="frm" id="GAR_ESTCIVIL" type="text" pInputText
										[(ngModel)]="cxcgarante.GAR_ESTCIVIL" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-1">
									<button type="button"
										style="background-image: url(../../../assets/images/iconos/buscar.webp);"
										(click)="busquedaestciv(cxcgarante.GAR_ESTCIVIL)"></button>
								</div>
								<div class="p-col-1">
									<label for="GAR_ESTCIVNOMBRE"></label>
									<input class="frm" id="GAR_ESTCIVNOMBRE" type="text" pInputText disabled
										[(ngModel)]="cxcgarante.GAR_ESTCIVNOMBRE" autocomplete="off">
								</div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -16px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
								<div class="p-col-1">
									<span class="obligatorio">Dirección:</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_DIRECCION"></label>
									<input class="frm" id="GAR_DIRECCION" type="text" pInputText
									[maxLength]="150"
										[(ngModel)]="cxcgarante.GAR_DIRECCION" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
									<span class="obligatorio">Teléfono 1:</span>
								</div>
                                <div class="p-col-1">
									<label for="GAR_TELEFONO1"></label>
                                    <input class="frm" id="GAR_TELEFONO1" type="text" pInputText oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                    maxlength="15"
										[(ngModel)]="cxcgarante.GAR_TELEFONO1" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-1">
									<span >Teléfono 2:</span>
								</div>
								<div class="p-col-1">
									<label for="GAR_TELEFONO2"></label>
                                    <input class="frm" id="GAR_TELEFONO2" type="text" pInputText oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                    maxlength="15"
										[(ngModel)]="cxcgarante.GAR_TELEFONO2" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
                            </div>
                        </div>

                        <div class="p-col-12" style="margin-top: -14px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
									<span class="obligatorio">Email 1:</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_CORREO"></label>
                                    <input class="frm" id="GAR_CORREO" type="text" pInputText
                                    maxlength="150"
										[(ngModel)]="cxcgarante.GAR_CORREO" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
                                </div>  
                                <div class="p-col-1"></div>                              
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-4">
                                            <p-checkbox id="chkbieninmueble" name="chkbieninmueble" value="" label=""
                                                binary="{{chkbieninmueble}}" [(ngModel)]="chkbieninmueble"
                                                (click)="botonesmodificar()" (keydown.enter)="setFocus($event)">
                                            </p-checkbox>
                                        </div>

                                        <div class="p-col-8">
                                            <span>Bien Inmueble</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-2">
                                    <label for="GAR_BIEINMDES"></label>
                                    <input class="frm" id="GAR_BIEINMDES" type="text" pInputText
                                    maxlength="200"
                                        [(ngModel)]="cxcgarante.GAR_BIEINMDES" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <span class="obligatorio">Ingresos Mensuales:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_INGMEN"></label>
                                    <input class="frm" id="GAR_INGMEN" type="text" pInputText
                                    oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');"
                                        [(ngModel)]="cxcgarante.GAR_INGMEN" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -14px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>

                                <div class="p-col-1">
									<span class="obligatorio">Sit. Laboral:</span>
                                </div>
                                <div class="p-col-2">
                                    <!-- <p-dropdown [options]="cmbNacio" [style]="{'width': '100%'}"
                                        [(ngModel)]="valorNacio" optionLabel="nacnombre" [panelStyle]="{'width':'110%'}"
                                        id="inp_Nacio" (onChange)="cambioOptionNac($event)"
                                        (keydown.enter)="setFocus($event)"></p-dropdown> -->
                                        <p-dropdown [options]="cmbSitLab" 
                                        optionLabel="name"  [(ngModel)]="valorSitLab"
                                        
                                        (onChange)="cambioOptionSitLab($event)"></p-dropdown>                                        
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-4">
                                            <p-checkbox id="chkvehiculo" name="chkvehiculo" value="" label=""
                                                binary="{{chkvehiculo}}" [(ngModel)]="chkvehiculo"
                                                (click)="botonesmodificar()" (keydown.enter)="setFocus($event)">
                                            </p-checkbox>
                                        </div>
                                        <div class="p-col-8">
                                            <span>Vehículo</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="p-col-2">
                                    <label for="GAR_VEHDES"></label>
                                    <input class="frm" id="GAR_VEHDES" type="text" pInputText
                                    maxlength="200"
                                        [(ngModel)]="cxcgarante.GAR_VEHDES" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                 <div class="divgrups">
					<div class="p-grid">
                        <div class="p-col-1">Datos Conyugue:</div>
						<div class="p-col-12">
							<div class="p-grid">
								<div class="p-col-1"></div>
								<div class="p-col-1">
									<span class="obligatorio">ID :</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_IDCONYUGE"></label>
									<input class="frm" id="GAR_IDCONYUGE" type="text" pInputText
									[maxLength]="10"
										[(ngModel)]="cxcgarante.GAR_IDCONYUGE" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">
									<span>Nombre :</span>
								</div>
								<div class="p-col-5">
									<label for="GAR_NOMCONY"></label>
									<input class="frm" id="GAR_NOMCONY" type="text" pInputText
									[maxLength]="200"
										[(ngModel)]="cxcgarante.GAR_NOMCONY" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
							</div>
						</div>
						<div class="p-col-12" style="margin-top: -15px">
							<div class="p-grid">
								<div class="p-col-1"></div>
								<div class="p-col-1">
									<span >Dirección :</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_DIRCONY"></label>
                                    <input class="frm" id="GAR_DIRCONY" type="text" pInputText
                                    maxlength="150"
										[(ngModel)]="cxcgarante.GAR_DIRCONY" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-1">
									<span>Teléfono :</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_TELCONY"></label>
                                    <input class="frm" id="GAR_TELCONY" type="text" pInputText
                                    oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                    maxlength="15"
										[(ngModel)]="cxcgarante.GAR_TELCONY" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-1">
									<span>Correo :</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_CORCONY"></label>
                                    <input class="frm" id="GAR_CORCONY" type="text" pInputText
                                    maxlength="150"
										[(ngModel)]="cxcgarante.GAR_CORCONY" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-2"></div>
							</div>
						</div>
						
					</div>
                </div> 
                <div class="divgrups">
					<div class="p-grid">
                        <div class="p-col-1">Datos Laborales:</div>
                        <div class="p-col-12">
							<div class="p-grid">
                                <div class="p-col-1"></div>
								<div class="p-col-1">
									<span >Nombre de la empresa:</span>
								</div>
								<div class="p-col-2">
									<label for="GAR_EMPTRA"></label>
									<input class="frm" id="GAR_EMPTRA" type="text" pInputText
									[maxLength]="150"
										[(ngModel)]="cxcgarante.GAR_EMPTRA" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">
									<span >Dirección:</span>
                                </div>
                                <div class="p-col-2">
									<label for="GAR_DIREMPTRA"></label>
									<input class="frm" id="GAR_DIREMPTRA" type="text" pInputText
									[maxLength]="150"
										[(ngModel)]="cxcgarante.GAR_DIREMPTRA" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -14px">
                            <div class="p-grid">
                                <div class="p-col-1"></div>
                                <div class="p-col-1">Teléfono:</div>
                                <div class="p-col-2">
                                    <label for="GAR_TELEMPTRA"></label>
                                    <input class="frm" id="GAR_TELEMPTRA" type="text" pInputText
                                    [maxLength]="30" oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                        [(ngModel)]="cxcgarante.GAR_TELEMPTRA" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                                <div class="p-col-1">Correo:</div>
                                <div class="p-col-2">
                                    <label for="GAR_COREMOTRA"></label>
                                    <input class="frm" id="GAR_COREMOTRA" type="text" pInputText
                                    [maxLength]="150"
                                        [(ngModel)]="cxcgarante.GAR_COREMOTRA" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()" autocomplete="off">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </p-tabPanel>

</p-tabView>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="false"
	[style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla"
		[where]="where"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<p-dialog header="Clave Autorización" [(visible)]="displayDialogAutorizacion" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" (onHide)="onHideAutorizacion()" [style]="{width: '40vw', height: 'auto'} ">
	<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="autorizacion"></p-toast>
	<div class="divgrups">
		<div class="p-grid">
			<div class="p-col-12">
				<div class="p-grid">
					<div class="p-col-1"></div>
					<div class="p-col-4">
						<label for="clave" style="font-weight: bold">Clave de Autorización:</label>
					</div>
					<div class="p-col-2"></div>
					<div class="p-col-4">
						<input type="password" pInputText id="clave" [(ngModel)]="claveAuth"
							(keydown.enter)="comprobarClave()" placeholder="Ingrese la clave">
					</div>
					<div class="p-col-1"></div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>
<p-dialog header="Documentos" [(visible)]="displayDialogDocumentos" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '50vw', height: 'auto'}">
	<app-uploadfiles *ngIf="displayDialogDocumentos" [txtOrigen]="'CXCMAEGARANTE'"
        [txtNumComprobante]="cxcgarante.GAR_ID"
        [boolpercont]="false"
		(signalSalir)="recibirSenalesDocumentos($event)">

	</app-uploadfiles>
</p-dialog>